import { render, staticRenderFns } from "./bottomWtxhM.vue?vue&type=template&id=66ca1e90&scoped=true"
import script from "./bottomWtxhM.vue?vue&type=script&lang=js"
export * from "./bottomWtxhM.vue?vue&type=script&lang=js"
import style0 from "./bottomWtxhM.vue?vue&type=style&index=0&id=66ca1e90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca1e90",
  null
  
)

export default component.exports